/**
 * Formatting utilities for the accounting feature
 */

import { currencyFormatter } from "helpers/formatters";

/**
 * Formats currency amounts for accounting displays
 * Uses the standard currencyFormatter with no decimal places for whole dollar amounts
 */
export const formatAccountingAmount = (
  amount: number | null | undefined,
): string => {
  if (amount === null || amount === undefined) {
    return "--";
  }

  // For accounting, we typically show whole dollars unless there are cents
  const hasDecimals = amount % 1 !== 0;

  return currencyFormatter(amount, {
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  });
};

/**
 * Formats payment button labels with currency amounts
 */
export const formatPaymentLabel = (
  amount: number | null | undefined,
): string => {
  if (!amount || amount <= 0) {
    return "Pay $0";
  }

  return `Pay ${formatAccountingAmount(amount)}`;
};

/**
 * Formats currency amounts for display in AG Grid cells and summaries
 * Always shows at least whole dollars (no decimals for whole amounts)
 */
export const formatGridCurrency = (
  amount: number | null | undefined,
): string => {
  if (amount === null || amount === undefined || isNaN(Number(amount))) {
    return "--";
  }

  return currencyFormatter(amount, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
